import {
  formatTransactionDate,
  getTransactionAssetLabel,
  getTransactionNarration,
  getTransactionSourceLabel,
  getTransactionTypeLabel,
  getUserTransactionAmountPlainText,
  getUserTransactionStatusLabel,
  type UserActivityTransaction,
} from "./userActivityTransactionUtils";

function csvEscape(cell: string): string {
  const s = String(cell ?? "");
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

function line(cells: string[]): string {
  return cells.map(csvEscape).join(",");
}

const HEADERS = [
  "First Name",
  "Last Name",
  "Asset",
  "Type",
  "Amount",
  "Transaction ID",
  "Date",
  "Status",
  "Source",
  "Description",
];

export function buildUserTransactionsExportCsv(
  transactions: UserActivityTransaction[],
  firstName: string,
  lastName: string
): string {
  const rows = transactions.map((tx) =>
    line([
      firstName || "N/A",
      lastName || "N/A",
      getTransactionAssetLabel(tx),
      getTransactionTypeLabel(tx),
      getUserTransactionAmountPlainText(tx),
      tx._id,
      formatTransactionDate(tx),
      getUserTransactionStatusLabel(tx),
      getTransactionSourceLabel(tx),
      getTransactionNarration(tx),
    ])
  );

  return [line(HEADERS), ...rows].join("\n");
}

export function buildUserTransactionsExportBasename(
  firstName: string,
  lastName: string,
  startDate: string,
  endDate: string
): string {
  const slug = (value: string) =>
    value
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "")
      .slice(0, 24);

  const from = startDate.replace(/-/g, "");
  const to = endDate.replace(/-/g, "");
  const name = [slug(firstName), slug(lastName)].filter(Boolean).join("-") || "user";

  return `${name}-transactions-${from}-${to}`;
}
